import React from 'react';
import Heading from '@tds/core-heading';
import PropTypes from 'prop-types';

import { formatPrice } from '../../../utils/utils';
import { modeOfPaymentValues, oneTimeAdditionalEquipment, easyAdditionalEquipment, localeFrench, fieldFrenchSecureBusiness, monthlyRecurringAdditionalEquipment, easyFiveYearAdditionalEquipment } from '../../../utils/constant';
import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import { useLocaleContext } from '../../../context/LocaleContext';

const SecureBusiness = ({ secureBusiness }) => {

  /**
   * it renders additionalEquipments dynamically
   * @param {String} additionalEquipment
   * @param {String} locale
   * @param {Object[]} additionalEquipments
   */
  const renderAdditionalEquipments = (additionalEquipment, locale, additionalEquipments) => {
    if (additionalEquipments && additionalEquipments.length > 0) {
      return additionalEquipments.map(
        ({
           value: ltoValue,
           qty: ltoQty,
           prices,
           modeOfPayment
         }) => {
          let paymentDescription;
          if (modeOfPayment === modeOfPaymentValues.ONE_TIME) {
            paymentDescription = oneTimeAdditionalEquipment;
          } else if (modeOfPayment === modeOfPaymentValues.MONTH_TO_MONTH) {
            paymentDescription = easyAdditionalEquipment;
          } else {
            paymentDescription = easyFiveYearAdditionalEquipment;
          }

          const description =
            locale === localeFrench
              ? `${additionalEquipment} : ${ltoValue}`
              : `${additionalEquipment} (${paymentDescription}) : ${ltoValue}`;
          return ((
              <tr key={`secureBusinessAdditionalEquipment${ltoValue}`}>
                <td>
                  {description}
                </td>
                <td>{ltoQty}</td>
                <td>{formatPrice(prices && prices.oneTime || 0)}</td>
                <td>{formatPrice(prices && prices.monthly || 0)}</td>
                <td>{formatPrice(prices && prices.monthlyFiveYear || 0)}</td>
              </tr>
            )
          );
        });
    }
    return null;
  };
  const renderMonthlyRecurringAdditionalEquipments = (
    monthlyRecurringEquipment,
    locale,
    additionalEquipment,
    temperatureServiceFee
  ) => {
    if ((!monthlyRecurringEquipment || monthlyRecurringEquipment.length === 0) && temperatureServiceFee <= 0) {
      return null;
    } 
    return (
      <>
        {monthlyRecurringEquipment &&
          monthlyRecurringEquipment.length > 0 &&
          monthlyRecurringEquipment.map(({ value: ltoValue, qty: ltoQty, prices, modeOfPayment }) => {
            let paymentDescription;
            if (modeOfPayment === modeOfPaymentValues.ONE_TIME) {
              paymentDescription = monthlyRecurringAdditionalEquipment;
            } else if (modeOfPayment === modeOfPaymentValues.MONTH_TO_MONTH) {
              paymentDescription = monthlyRecurringAdditionalEquipment;
            } else {
              paymentDescription = monthlyRecurringAdditionalEquipment;
            }

            const description =
              locale === localeFrench
                ? `${additionalEquipment} : ${ltoValue}`
                : `${additionalEquipment} (${paymentDescription}) : ${ltoValue}`;

            return (
              <tr key={`secureBusinessAdditionalEquipment${ltoValue}`}>
                <td>{description}</td>
                <td>{ltoQty}</td>
                <td>{formatPrice((prices && prices.oneTime) || 0)}</td>
                <td>{formatPrice((prices && prices.monthly) || 0)}</td>
                <td>{formatPrice((prices && prices.monthlyFiveYear) || 0)}</td>
              </tr>
            );
          })}

        {temperatureServiceFee > 0 && (
          <tr key="temperatureMonitoringFee">
            <td>Additional Equipment (Monthly Recurring) : Temperature Monitoring Fee</td>
            <td>1</td>
            <td>{formatPrice(0)}</td>
            <td>{formatPrice(temperatureServiceFee)}</td>
            <td>{formatPrice(0)}</td>
          </tr>
        )}
      </>
    );
  };
  const {
    quoteSummary: {
      products: { secureBusiness: productLabel },
      includedEquipment,
      selectedEquipment,
      additionalEquipment,
      regularOffer,
      limitedTimeOffer,
      securityPackage,
      securityPackageFeatures,
      table: { qty, oneTimeCharges, monthlyCharges, total ,monthlyFiveYearCharges,monthlyThreeYearCharges},
      secureBusinessPackages
    }
  } = useLocalizedStringsContext();
  const {
    tsbTerm,
    securityPackage: {
      value: packageValue,
      qty: packageQty,
      prices: { oneTime: packageOneTime, monthly: packageMonthly,monthlyFiveYear } = {}
    } = {},
    Installation: {
      prices: { oneTime: installationOneTime } = {}
    } = {},
    limitedTimeOffers,
    regularOffers,
    additionalEquipments,
    additionalEquipmentsEasyPayments,
    monthlyRecurringEquipment,
    includedEquipments,
    selectedEquipments,
    totalMonthly,
    totalOneTime,
    totalMonthlyFiveYear,
    features
  } = secureBusiness || {};
  const locale = useLocaleContext();
  const securityPackageTranslation = secureBusinessPackages[packageValue] || packageValue;
  const productLabelValue = locale !== localeFrench ? productLabel : fieldFrenchSecureBusiness;
  return (
    <>
      {secureBusiness && (
        <div style={{ overflowX: 'auto' }}>
          <Heading level="h3">{productLabelValue}</Heading>
          <br />
          <table>
            <thead>
            <tr>
              <th width="80%"></th>
              <th>{qty}</th>
              <th>{oneTimeCharges}</th>
              <th>{monthlyThreeYearCharges}</th>
              <th>{monthlyFiveYearCharges}</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>
                Term: {(tsbTerm && tsbTerm.value) || ''}
              </td>
            </tr>
            <tr>
              <td>
                {securityPackage}: {securityPackageTranslation}
              </td>
              <td>{packageQty}</td>
              <td>{formatPrice(packageOneTime)}</td>
              <td>{formatPrice(packageMonthly)}</td>
              <td>{formatPrice(monthlyFiveYear)}</td>
            </tr>
            <tr>
              <td>Installation: Installation Fee</td>
              <td></td>
              <td>{formatPrice(installationOneTime)}</td>
            </tr>
            {includedEquipments &&
              includedEquipments.length > 0 &&
              includedEquipments.map(
                ({
                   value: ltoValue,
                   qty: ltoQty,
                   prices: { oneTime: ltoOneTime, monthly: ltoMonthly ,monthlyFiveYear: ltoMonthlyFiveYear} = {}
                 }) => (
                  <tr key={`secureBusinessIncludedEquipment${ltoValue}`}>
                    <td>
                      {includedEquipment}: {ltoValue}
                    </td>
                    <td>{ltoQty}</td>
                    <td>{formatPrice(ltoOneTime)}</td>
                    <td>{formatPrice(ltoMonthly)}</td>
                    <td>{formatPrice(ltoMonthlyFiveYear)}</td>
                  </tr>
                )
              )}

            {selectedEquipments &&
              selectedEquipments.length > 0 &&
              selectedEquipments.map(
                ({
                   value: ltoValue,
                   qty: ltoQty,
                   prices: { oneTime: ltoOneTime, monthly: ltoMonthly, monthlyFiveYear: ltoMonthlyFiveYear } = {}
                 }) => (
                  <tr key={`secureBusinessSelectedEquipment${ltoValue}`}>
                    <td>
                      {selectedEquipment}: {ltoValue}
                    </td>
                    <td>{ltoQty}</td>
                    <td>{formatPrice(ltoOneTime)}</td>
                    <td>{formatPrice(ltoMonthly)}</td>
                    <td>{formatPrice(ltoMonthlyFiveYear)}</td>
                  </tr>
                )
              )}

            {renderAdditionalEquipments(additionalEquipment, locale, additionalEquipments)}
              {(monthlyRecurringEquipment && monthlyRecurringEquipment.length > 0) ||
                secureBusiness.temperatureServiceFee > 0 ? (
                  renderMonthlyRecurringAdditionalEquipments(
                    monthlyRecurringEquipment,
                    locale,
                    'Additional Equipment',
                    secureBusiness.temperatureServiceFee
                  )
                ) : null}
            {regularOffers &&
              regularOffers.length > 0 &&
              regularOffers.map(
                ({
                   value: roValue,
                   qty: roQty,
                   prices: { oneTime: roOneTime, monthly: roMonthly , monthlyFiveYear: roMonthlyFiveYear} = {}
                 }) => (
                  <tr key={`secureBusinessRegularOffer${roValue}`}>
                    <td>
                      {regularOffer}: {roValue}
                    </td>
                    <td>{roQty}</td>
                    <td>{formatPrice(roOneTime)}</td>
                    <td>{formatPrice(roMonthly)}</td>
                    <td>{formatPrice(roMonthlyFiveYear)}</td>
                  </tr>
                )
              )}
            {limitedTimeOffers &&
              limitedTimeOffers.length > 0 &&
              limitedTimeOffers.map(
                ({
                   value: ltoValue,
                   qty: ltoQty,
                   prices: { oneTime: ltoOneTime, monthly: ltoMonthly, monthlyFiveYear:ltoMonthlyFiveYear } = {}
                 }) => (
                  <tr key={`secureBusinessLimitedOffer${ltoValue}`}>
                    <td>
                      {limitedTimeOffer}: {ltoValue}
                    </td>
                    <td>{ltoQty}</td>
                    <td>{formatPrice(ltoOneTime)}</td>
                    <td>{formatPrice(ltoMonthly)}</td>
                    <td>{formatPrice(ltoMonthlyFiveYear)}</td>
                  </tr>
                )
              )}
            {features &&
              features.length > 0 &&
              features.map(
                ({
                   value: ltoValue,
                   qty: ltoQty,
                   prices: { oneTime: ltoOneTime, monthly: ltoMonthly , monthlyFiveYear: ltoMonthlyFiveYear} = {}
                 }) => (
                  <tr key={`secureBusinessLimitedOffer${ltoValue}`}>
                    <td>
                      {securityPackageFeatures}: {ltoValue}
                    </td>
                    <td>{ltoQty}</td>
                    <td>{formatPrice(ltoOneTime)}</td>
                    <td>{formatPrice(ltoMonthly)}</td>
                    <td>{formatPrice(ltoMonthlyFiveYear)}</td>
                  </tr>
                )
              )}
            <tr>
              <td>{total}</td>
              <td></td>
              <td>{formatPrice(totalOneTime)}</td>
              <td>{formatPrice(totalMonthly)}</td>
              <td>{formatPrice(totalMonthlyFiveYear)}</td>
            </tr>
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

SecureBusiness.defaultProps = {
  secureBusiness: {}
};

SecureBusiness.propTypes = {
  secureBusiness: PropTypes.objectOf(PropTypes.any)
};

export default SecureBusiness;
